import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M14.447 7.106a1 1 0 0 1 .447 1.341l-4 8a1 1 0 1 1-1.788-.894l4-8a1 1 0 0 1 1.341-.447M7.6 7.2a1 1 0 0 1 .2 1.4L5.25 12l2.55 3.4a1 1 0 0 1-1.6 1.2l-3-4a1 1 0 0 1 0-1.2l3-4a1 1 0 0 1 1.4-.2m8.8 0a1 1 0 0 0-.2 1.4l2.55 3.4-2.55 3.4a1 1 0 0 0 1.6 1.2l3-4a1 1 0 0 0 0-1.2l-3-4a1 1 0 0 0-1.4-.2",
      clipRule: "evenodd"
    }
  )
);
var SvgContextualRoutingOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ContextualRoutingOutlined_default = SvgContextualRoutingOutlined;

export { ContextualRoutingOutlined_default as default };
